import { Zap, MessageCircle, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";
import { CONTACT_CONFIG } from "../config/contact";
import GridTexture from "./GridTexture";

function scrollToPricing(e) {
  e.preventDefault();
  const el = document.getElementById("pricing");
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

export default function FinalCTA() {
  const { whatsappUrl: WHATSAPP_URL } = CONTACT_CONFIG;
  return (
    <section className="relative overflow-hidden bg-surface-primary border-y border-line py-16 sm:py-20">
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 15% 20%, rgba(0,212,255,0.28), transparent 45%), radial-gradient(circle at 85% 85%, rgba(236,72,153,0.22), transparent 55%), radial-gradient(circle at 50% 50%, rgba(139,92,246,0.18), transparent 60%)",
        }}
      />
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10 text-center">
        <Reveal className="max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-accent-soft border border-accent/25 rounded-full px-4 py-1.5 text-accent text-xs font-bold uppercase tracking-[0.18em] mb-5">
            <Zap className="w-3.5 h-3.5 text-accent" />
            Directe activering
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-snug mb-4">
            Klaar om alles op één plek te kijken?
          </h2>
          <p className="text-ink-secondary text-sm sm:text-base md:text-lg mb-8">
            Kies je pakket, reken veilig af en ontvang direct toegang tot 79.000+ zenders
            en 249.000+ films en series in 4K.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href="#pricing"
              onClick={scrollToPricing}
              className="w-full sm:w-auto bg-gradient-button hover:brightness-110 text-white font-black px-8 py-3.5 rounded-xl shadow-glow-purple hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 min-h-[48px]"
            >
              <Zap className="w-5 h-5" />
              Bekijk Onze Pakketten
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-white/5 hover:bg-white/10 border border-line hover:border-accent/40 text-white font-bold px-8 py-3.5 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 min-h-[48px]"
            >
              <MessageCircle className="w-5 h-5" />
              Stel een Vraag via WhatsApp
            </a>
          </div>
          <div className="mt-6 inline-flex items-center gap-2 text-ink-secondary text-xs sm:text-sm font-medium">
            <ShieldCheck className="w-4 h-4 text-accent" />
            15 dagen geld-terug-garantie · 100% veilig betalen
          </div>
        </Reveal>
      </div>
    </section>
  );
}
